import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from '../../../../environments/environment';
import { ApiResponse } from '../../../core/models/api.models';
import { AuthConfigService } from '../../../core/services/auth-config.service';
import { AuthLoginPayload, AuthTokensPayload, AuthUser } from '../models/auth.models';

@Injectable({ providedIn: 'root' })
export class AuthApiService {
  readonly #config = inject(AuthConfigService);
  readonly #http = inject(HttpClient);
  readonly #baseUrl = `${environment.apiBaseUrl}/auth`;

  login(payload: AuthLoginPayload): Observable<AuthTokensPayload> {
    return this.#http
      .post<ApiResponse<AuthTokensPayload>>(
        `${this.#baseUrl}/login`,
        {
          [this.#config.loginField]: payload.identifier,
          password: payload.password,
        },
        {
          withCredentials: true,
        },
      )
      .pipe(map((response) => response.data));
  }

  refresh(): Observable<AuthTokensPayload> {
    return this.#http
      .post<ApiResponse<AuthTokensPayload>>(
        `${this.#baseUrl}/refresh`,
        {},
        {
          withCredentials: true,
        },
      )
      .pipe(map((response) => response.data));
  }

  logout(): Observable<void> {
    return this.#http.post<void>(
      `${this.#baseUrl}/logout`,
      {},
      {
        withCredentials: true,
      },
    );
  }

  me(): Observable<AuthUser> {
    return this.#http
      .get<ApiResponse<AuthUser>>(`${this.#baseUrl}/me`, {
        withCredentials: true,
      })
      .pipe(map((response) => response.data));
  }
}
